//****************************************
// Plot Legend Prototype
// DOM Registration: Not an element
// National Instruments Copyright 2015
//****************************************

(function () {
    'use strict';

    // Constructor Function
    NationalInstruments.HtmlVI.Elements.PlotLegendItemDisplay = function (helpers) {
        this.pointTypes = [
            { name: 'ellipse', creator: createEllipseShape },
            { name: 'rectangle', creator: createRectangleShape },
            { name: 'diamond', creator: createDiamondShape },
            { name: 'cross', creator: createCrossShape },
            { name: 'plus', creator: createPlusShape }
        ];

        this.lineTypes = [
            { name: 'line', creator: createLine },
            { name: 'fill', creator: createFillArea },
            { name: 'bar', creator: createBars },
            { name: 'points', creator: createPoints }
        ];

        this.shapes = [];
        this.helpers = helpers;
    };

    // Static Public Variables
    // None

    var child = NationalInstruments.HtmlVI.Elements.PlotLegendItemDisplay;
    var proto = child.prototype;

    // Static Private Variables
    // None

    // Static Private Functions
    // None

    // Public Prototype Methods
    proto.createHeaderDisplay = function (div, index) {
        var svgns, svg;
        svgns = 'http://www.w3.org/2000/svg';
        svg = document.createElementNS(svgns, 'svg');
        svg.setAttribute('width', '16');
        svg.setAttribute('height', '16');
        svg.setAttribute('viewBox', '0,0,16,16');
        svg.setAttributeNS('http://www.w3.org/2000/xmlns/', 'xmlns:xlink', 'http://www.w3.org/1999/xlink');
        div.appendChild(svg);

        var shapesGroup = document.createElementNS(svgns, 'g');
        var that = this;
        svg.appendChild(shapesGroup);
        this.shapes[index] = {};
        this.shapes[index].shapesGroup = shapesGroup;

        createLineTypes(index, shapesGroup, svgns, that);
        shapesGroup.setAttribute('stroke', 'rgba(255, 0, 0, 1)');
    };

    proto.removeHeaderDisplay = function (div, index) {
        this.shapes.splice(index, 1);
    };

    var createLineTypes = function (index, shapesGroup, svgns, plotLegendItemDisplay) {
        var i;

        for (i = 0; i < plotLegendItemDisplay.lineTypes.length; i++) {
            plotLegendItemDisplay.lineTypes[i].creator(index, shapesGroup, svgns, plotLegendItemDisplay);
        }
    };

    var createLine = function (index, shapesGroup, svgns, plotLegendItemDisplay) {
        var shape = document.createElementNS(svgns, 'polyline');
        shape.setAttribute('points', '0,15 5,5 10,10 15,0');
        shape.setAttribute('fill', 'none');
        shape.setAttribute('stroke-width', plotLegendItemDisplay.helpers.getLineWidth(index));
        shape.setAttribute('stroke-dasharray', plotLegendItemDisplay.helpers.getLineStyle(index));

        shapesGroup.appendChild(shape);
        plotLegendItemDisplay.shapes[index].shapesGroup.line = shape;
    };

    var createFillArea = function (index, shapesGroup, svgns, plotLegendItemDisplay) {
        var shape = document.createElementNS(svgns, 'polyline');
        shape.setAttribute('points', '0,15 5,5 10,10 15,0, 15,15, 0,15');
        shape.setAttribute('fill', plotLegendItemDisplay.helpers.getPlotColor(index));
        shape.setAttribute('stroke-width', plotLegendItemDisplay.helpers.getLineWidth(index));
        shape.setAttribute('visibility', 'hidden');

        shapesGroup.appendChild(shape);
        plotLegendItemDisplay.shapes[index].shapesGroup.fill = shape;
    };

    var createBars = function (index, shapesGroup, svgns, plotLegendItemDisplay) {
        var shape = document.createElementNS(svgns, 'polyline');
        shape.setAttribute('points', '1.5,15.5 1.5,12.5, 4.5,12.5 4.5,15.5 6.5,15.5 6.5,3.5, 9.5,3.5 9.5,15.5 11.5,15.5 11.5,7.5 14.5,7.5 14.5,15.5 1.5,15.5');
        shape.setAttribute('fill', plotLegendItemDisplay.helpers.getPlotColor(index));
        shape.setAttribute('stroke-width', 1);
        shape.setAttribute('visibility', 'hidden');

        shapesGroup.appendChild(shape);
        plotLegendItemDisplay.shapes[index].shapesGroup.bar = shape;
    };

    var createPoints = function (index, shapesGroup, svgns, plotLegendItemDisplay) {
        var i, j;
        var group;
        var points = [
            { x: 0.5, y: 15.5 },
            { x: 10.5, y: 10.5 },
            { x: 5.5, y: 5.5 },
            { x: 15.5, y: 0.5 }
        ];
        var shape;

        var pointGroups = document.createElementNS(svgns, 'g');
        plotLegendItemDisplay.shapes[index].shapesGroup.points = pointGroups;
        for (j = 0; j < plotLegendItemDisplay.pointTypes.length; j++) {
            group = document.createElementNS(svgns, 'g');
            for (i = 0; i < 4; i++) {
                shape = plotLegendItemDisplay.pointTypes[j].creator(svgns, points[i], 4);
                group.appendChild(shape);
            }

            group.setAttribute('fill', plotLegendItemDisplay.helpers.getPlotColor(index));
            group.setAttribute('stroke-width', 1);
            group.setAttribute('visibility', 'hidden');
            pointGroups.appendChild(group);
            plotLegendItemDisplay.shapes[index].shapesGroup.points[plotLegendItemDisplay.pointTypes[j].name] = group;
        }

        shapesGroup.appendChild(pointGroups);
    };

    var createEllipseShape = function (svgns, center, size) {
        var shape = document.createElementNS(svgns, 'circle');
        shape.setAttribute('cx', center.x);
        shape.setAttribute('cy', center.y);
        shape.setAttribute('r', size / 2);
        return shape;
    };

    var createRectangleShape = function (svgns, center, size) {
        var shape = document.createElementNS(svgns, 'rect');
        shape.setAttribute('x', center.x - size / 2);
        shape.setAttribute('y', center.y - size / 2);
        shape.setAttribute('width', size);
        shape.setAttribute('height', size);
        return shape;
    };

    var createDiamondShape = function (svgns, center, size) {
        var shape = document.createElementNS(svgns, 'path');
        var path = 'M' + (center.x - size / 2) + ',' + center.y;
        path += ' L' + center.x + ',' + (center.y - size / 2);
        path += ' L' + (center.x + size / 2) + ',' + center.y;
        path += ' L' + center.x + ',' + (center.y + size / 2);
        path += ' Z';
        shape.setAttribute('d', path);
        return shape;
    };

    var createCrossShape = function (svgns, center, size) {
        var shape = document.createElementNS(svgns, 'path');
        var path = 'M' + (center.x - size / 2) + ',' + (center.y - size / 2);
        path += ' L' + (center.x + size / 2) + ',' + (center.y + size / 2);
        path += 'M' + (center.x + size / 2) + ',' + (center.y - size / 2);
        path += ' L' + (center.x - size / 2) + ',' + (center.y + size / 2);
        shape.setAttribute('d', path);
        return shape;
    };

    var createPlusShape = function (svgns, center, size) {
        var shape = document.createElementNS(svgns, 'path');
        var path = 'M' + center.x + ',' + (center.y - size / 2);
        path += ' L' + center.x + ',' + (center.y + size / 2);
        path += 'M' + (center.x - size / 2) + ',' + center.y;
        path += ' L' + (center.x + size / 2) + ',' + center.y;
        shape.setAttribute('d', path);
        return shape;
    };

    proto.updateLinesAttributes = function (index, group, color) {
        var lineShape = this.helpers.getLineShape(index);

        if (lineShape === 'line' || lineShape === 'line & point') {
            group.line.setAttribute('stroke-width', this.helpers.getLineWidth(index));
            group.line.setAttribute('stroke-dasharray', this.helpers.getLineStyle(index));
        }

        group.fill.setAttribute('fill', color);
        group.bar.setAttribute('fill', color);
        for (var i = 0; i < this.pointTypes.length; i++) {
            group.points[this.pointTypes[i].name].setAttribute('fill', color);
        }
    };

    proto.updatePointVisibility = function (index, group, currentLineShape) {
        var currentPointShape = this.helpers.getPointShape(index);
        for (var j = 0; j < this.pointTypes.length; j++) {
            if (currentPointShape === this.pointTypes[j].name && (currentLineShape === 'line & point' || currentLineShape === 'points')) {
                group.points[this.pointTypes[j].name].setAttribute('visibility', 'visible');
            } else {
                group.points[this.pointTypes[j].name].setAttribute('visibility', 'hidden');
            }
        }
    };

    proto.updateVisibility = function (index, group) {
        var currentLineShape = this.helpers.getLineShape(index);

        for (var i = 0; i < this.lineTypes.length; i++) {
            if (currentLineShape === this.lineTypes[i].name) {
                group[this.lineTypes[i].name].setAttribute('visibility', 'visible');
            } else {
                group[this.lineTypes[i].name].setAttribute('visibility', 'hidden');
            }
        }

        if (currentLineShape === 'line & point') {
            group.line.setAttribute('visibility', 'visible');
            group.points.setAttribute('visibility', 'visible');
        }

        this.updatePointVisibility(index, group, currentLineShape);
    };

    proto.updateShape = function (index) {
        var shape = this.shapes[index];

        if (shape === undefined || shape === null) {
            return;
        }

        var color = this.helpers.getPlotColor(index);

        this.updateLinesAttributes(index, shape.shapesGroup, color);
        this.updateVisibility(index, shape.shapesGroup);
        shape.shapesGroup.setAttribute('stroke', color);
    };
}());
